import apiClient from '../apiClient';
import { GET_CITY_BY_REGION_URL } from '../apiUrl';

const getCityByRegionApi = Id => {
  return apiClient.get(GET_CITY_BY_REGION_URL(Id));
};

export default getCityByRegionApi;
